import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: MetaPixelFunction;
  loaded?: boolean;
  version?: string;
};
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const pixel = ((...args: unknown[]) => {
      if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
    }) as MetaPixelFunction;
    pixel.queue = [];
    pixel.push = pixel;
    pixel.loaded = true;
    pixel.version = '2.0';
    window.fbq = pixel;
    window._fbq = pixel;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    pixel('init', '1347508020831593');
    pixel('track', 'PageView');
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="38l8h7pmotugu">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1347508020831593&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="38kqbm2e4y3w9" />
      </noscript>
      <div className="min-h-screen bg-brand-ivory text-brand-text overflow-x-hidden flex flex-col items-center" data-id="element-2" data-mp="nv1284w7baay">
        <div className="w-full max-w-2xl bg-white shadow-xl" data-id="element-3" data-mp="swqcvjfihlyi">
          <UrgencyBanner data-id="element-4" data-mp="35gmx6tbedlm" />
          <Hero data-id="element-5" data-mp="34nc9ur8j3y7" />
          <PainSection data-id="element-6" data-mp="38b6yx8f1wei" />
          <SolutionSection data-id="element-7" data-mp="3udawg7dqol46" />
          <BonusSection data-id="element-8" data-mp="3ubzt28o7hfdl" />
          <BenefitsSection data-id="element-9" data-mp="3ucje3y95kjvu" />
          <PricingCard data-id="element-10" data-mp="d4nuteha5g1c" />
          <Guarantee data-id="element-11" data-mp="d4xopd5g47cb" />
          <Testimonials data-id="element-12" data-mp="d3cwvvain2i5" />
          <FAQ data-id="element-13" data-mp="d2l8b4fc651d" />
          <FinalCTA data-id="element-14" data-mp="85l2mumef4as" />
          <Footer data-id="element-15" data-mp="851m9icecnyv" />
        </div>
      </div>
    </>;
}